export const backMotion = {
  initial: { x: 0 },
  hover: { x: -5 },
};
